import { render } from "./FAQs.vue?vue&type=template&id=5fb9a3c2&scoped=true"
import script from "./FAQs.vue?vue&type=script&lang=js"
export * from "./FAQs.vue?vue&type=script&lang=js"

import "./FAQs.vue?vue&type=style&index=0&id=5fb9a3c2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5fb9a3c2"

export default script